import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";
import styles from "../../Styles";
import { PageReference } from "../PageReference";

const SectionTitle = ({
    t,
    title,
    number,
    anchorId,
    backgroundColor,
    breakBefore = false,
}) => {
    const sectionStyle = {
        ...styles.sectionTitle,
        ...(backgroundColor ? { backgroundColor } : {}),
    };

    const content = (
        <View style={styles.sectionBlock}>
            <PageReference id={anchorId} />
            <Text style={sectionStyle}>
                {number ? `${number}. ${t(title)}` : t(title)}
            </Text>
        </View>
    );

    if (breakBefore) {
        return <View break>{content}</View>;
    }

    return content;
};

export default withNamespaces()(SectionTitle);
